export interface ConnectedDevice {
  id: string;
  name: string;
  type: 'glucose_monitor' | 'heart_monitor' | 'fitness_tracker' | 'smart_scale' | 'blood_pressure' | 'pulse_oximeter';
  brand: string;
  status: 'connected' | 'disconnected' | 'syncing' | 'error';
  lastSync: string;
  batteryLevel?: number;
  dataPoints: number;
  metrics: string[];
}

export interface TelemetryData {
  timestamp: string;
  deviceId: string;
  metric: string;
  value: number;
  unit: string;
  source: string;
}

export const exampleConnectedDevices: ConnectedDevice[] = [
  {
    id: 'glucose-1',
    name: 'FreeStyle Libre 3',
    type: 'glucose_monitor',
    brand: 'Abbott',
    status: 'connected',
    lastSync: '2024-01-15T15:30:00Z',
    batteryLevel: 87,
    dataPoints: 2840,
    metrics: ['Glucose Level', 'Trend Arrow', 'Time in Range']
  },
  {
    id: 'watch-1',
    name: 'Apple Watch Series 9',
    type: 'fitness_tracker',
    brand: 'Apple',
    status: 'connected',
    lastSync: '2024-01-15T15:45:00Z',
    batteryLevel: 65,
    dataPoints: 15420,
    metrics: ['Heart Rate', 'Steps', 'Sleep', 'Blood Oxygen', 'ECG']
  },
  {
    id: 'bp-1',
    name: 'Omron HeartGuide',
    type: 'blood_pressure',
    brand: 'Omron',
    status: 'syncing',
    lastSync: '2024-01-15T12:00:00Z',
    batteryLevel: 45,
    dataPoints: 156,
    metrics: ['Systolic BP', 'Diastolic BP', 'Pulse']
  },
  {
    id: 'scale-1',
    name: 'Withings Body+',
    type: 'smart_scale',
    brand: 'Withings',
    status: 'connected',
    lastSync: '2024-01-15T08:30:00Z',
    batteryLevel: 92,
    dataPoints: 89,
    metrics: ['Weight', 'Body Fat %', 'Muscle Mass', 'BMI']
  }
];

export const exampleTelemetryData: TelemetryData[] = [
  {
    timestamp: '2024-01-15T15:30:00Z',
    deviceId: 'glucose-1',
    metric: 'Glucose Level',
    value: 142,
    unit: 'mg/dL',
    source: 'FreeStyle Libre 3'
  },
  {
    timestamp: '2024-01-15T15:45:00Z',
    deviceId: 'watch-1',
    metric: 'Heart Rate',
    value: 72,
    unit: 'bpm',
    source: 'Apple Watch'
  },
  {
    timestamp: '2024-01-15T15:45:00Z',
    deviceId: 'watch-1',
    metric: 'Blood Oxygen',
    value: 98,
    unit: '%',
    source: 'Apple Watch'
  },
  {
    timestamp: '2024-01-15T12:00:00Z',
    deviceId: 'bp-1',
    metric: 'Blood Pressure',
    value: 128,
    unit: 'mmHg',
    source: 'Omron HeartGuide'
  }
]; 